import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { lazy } from 'react';

const AgePage = lazy(() => import('./AgePage'));

const path = 'reports/age/live';
const AgeRoute: FuseRouteItemType = {
	path: path,
	element: <AgePage />,
	settings: {
		layout: {
			config: {
				toolbar: {
					title: 'Domain Age Analysis for Active Domains',
					showCrumbs: false,
					helpName: 'Age Live'
				},
			}
		}
	}
};

export default AgeRoute;
